module.exports = __webpack_public_path__ + "assets/img/BeepingFullfilment.d5699e06.png";